import { Card, CardBody, Checkbox as CheckboxInput } from '@heroui/react';
import { useState } from 'react';
import _ from 'lodash';

export function Checkbox({ answerHistory, data, sendAnswer }) {
  const initAnswer = answerHistory || new Array(data.length).fill(false);
  const [answers, setAnswer] = useState(initAnswer);

  const handleInputChange = (value, key) => {
    const answersClone = [...answers];

    if (_.toNumber(key) === data.length - 1) {
      answersClone.fill(false);
    } else {
      answersClone[data.length - 1] = false;
    }

    answersClone[key] = value;
    setAnswer(answersClone);
    sendAnswer(answersClone);
  };

  return (
    <>
      <Card isBlurred shadow="sm">
        <CardBody>
          {data.map((item) => (
            <CheckboxInput
              key={item.key}
              className="p-4"
              isSelected={answers[item.key]}
              onValueChange={(value) => handleInputChange(value, item.key)}
            >
              {item.text}
            </CheckboxInput>
          ))}
        </CardBody>
      </Card>
    </>
  );
}
